import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./CustomNumberInput.css";

const CustomNumberInput = ({
  defaultCountry,
  errors,
  state,
  setState,
  fieldName,
  ref,
  placeholder,
  quotation,
}) => {
  return (
    <PhoneInput
      ref={ref}
      defaultCountry={defaultCountry ? defaultCountry : "MU"}
      className={`tw-w-full tw-h-12 tw-border tw-border-black/50 !tw-rounded-sm tw-pl-4 d-flex ${
        errors.phoneNumber && "is-invalid"
      } ila-inactive-input`}
      placeholder={placeholder ? placeholder : "Enter phone number"}
      value={fieldName ? state[fieldName] : state.phoneNumber}
      onChange={(val) => {
        // if (quotation != undefined) {
        //   if (!quotation.userId) {
        if (fieldName) {
          const newState = { ...state };
          newState[fieldName] = val;
          setState(newState);
        } else {
          setState({ ...state, phoneNumber: val });
        }
        // } else {
        //   setState(state);
        // }
        // } else {
        //   if (fieldName) {
        //     const newState = { ...state };
        //     newState[fieldName] = val;
        //     setState(newState);
        //   } else {
        //     setState({ ...state, phoneNumber: val });
        //   }
        // }
      }}
    />
  );
};

export default CustomNumberInput;
